<template lang="html">
  <div class="content">
    <div>  <!-- Because without this, the accordion doesn't calculate size correctly -->
      <table class="table">
        <tr>
          <td class="cell--keys"><span class="keyboard-key--space">Space</span></td>
          <td class="cell--keys"><span class="keyboard-key">▲</span><span class="keyboard-key">▼</span></td>
          <td class="cell--keys"><span class="keyboard-key">R</span></td>
        </tr>
        <tr>
          <td class="cell">Start &amp; pause</td>
          <td class="cell">Adjust duration</td>
          <td class="cell">Reset</td>
        </tr>
      </table>
      <table class="table">
        <tr>
          <td class="cell">
            <span class="keyboard-key">1</span><span class="keyboard-key">2</span><span class="keyboard-key">3</span><span class="keyboard-key">4</span><span class="keyboard-key">5</span><span class="keyboard-key">6</span><span class="keyboard-key">7</span><span class="keyboard-key">8</span><span class="keyboard-key">9</span><span class="keyboard-key">0</span>
          </td>
        </tr>
        <tr>
          <td class="cell numbers-text">
            <p><span class="touch">If you have a keyboard, use its numbers</span><span class="no-touch">Use the numbers on your keyboard</span> to set a duration in minutes.</p>
          </td>
        </tr>
      </table>
      <table class="table">
        <tr>
          <td class="cell--keys"><span class="keyboard-key">T</span></td>
          <td class="cell--keys">
            <span class="keyboard-key">Shift</span> + <span class="keyboard-key">R</span>
          </td>
          <td class="cell--keys">
            <span class="keyboard-key">F</span>
          </td>
        </tr>
        <tr>
          <td class="cell">Enter a duration</td>
          <td class="cell">Toggle repeat</td>
          <td class="cell">Enter &amp; leave fullscreen</td>
        </tr>
      </table>
      <p>All shortcuts work while the timer is running too.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationContentKeyboard",
};
</script>

<style scoped lang="scss">
@import "../style/abstracts/variables.scss";
@import "../style/abstracts/functions.scss";
@import "../style/abstracts/mixins.scss";

// Responsive content
.no-touch {
  display: none;
}
.no-touch-events {
  .touch {
    display: none;
  }
  .no-touch {
    display: inline;
  }
}

$table-top-and-bottom-margin: $large;
$keyboard-key-top-margin: $tiny;
// Table with the keys
.table {
  margin-top: $default - $keyboard-key-top-margin + rem;
  margin-right: auto;
  margin-left: auto;
  word-wrap: break-word;
}
.cell,
.cell--keys {
  text-align: center;
  padding-right: $small + rem;
  padding-left: $small + rem;

  @media (min-width: 390px) {
    padding-right: $default + rem;
    padding-left: $default + rem;
  }

  p:last-child {
    margin-bottom: 0;
  }
}
.cell--keys {
  white-space: nowrap;
}
.cell:first-child,
.cell--keys:first-child {
  padding-left: 0;
  @media (min-width: 390px) {
    padding-left: 0;
  }
}
.cell:last-child,
.cell--keys:last-child {
  padding-right: 0;
  @media (min-width: 390px) {
    padding-right: 0;
  }
}

$pad: 3 * $tiny;
$width: 5 * $small;

.keyboard-key,
.keyboard-key--space {
  display: inline-block;
  margin-top: $keyboard-key-top-margin + rem;

  min-width: auto;
  height: $default + 0.2 + rem;
  padding-right: 0.5 + rem;
  padding-left: 0.5 + rem;

  text-align: center;
  line-height: 2.3rem;
  @include bold-text;

  border: 1.5px solid $color-dark;
  border-radius: 0.3rem;

  @media (min-width: 500px) {
    min-width: $width + rem;
    padding-right: $pad + rem;
    padding-left: $pad + rem;
  }
}
.keyboard-key:not(:first-child) {
  margin-left: $tiny + rem;
}
.keyboard-key--space {
  width: 100%;

  @media (min-width: 500px) {
    padding-right: $large + rem;
    padding-left: $large + rem;
  }
}
.numbers-text {
  text-align: left;
}
.table:first-of-type {
  margin-top: $table-top-and-bottom-margin + rem;
}
.table:last-of-type {
  margin-bottom: $table-top-and-bottom-margin + rem;
}
</style>



// WEBPACK FOOTER //
// src/components/NotificationContentKeyboard.vue